import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import SingleImageTab from './SingleImageTab';
import MultipleImageUploadTab from './MultipleImageUploadTab';

export default function ImageUploaderPage() {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box className='' sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Single Image upload" value="1" />
            <Tab label="Multiple Image upload" value="2" />
           
          </TabList>
        </Box>
        <TabPanel value="1">
            <SingleImageTab />
        </TabPanel>
        <TabPanel value="2">
            <MultipleImageUploadTab />
        </TabPanel>

      </TabContext>
    </Box>
  );
}